import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import Button from "../../components/Button";
import { Page } from "../../components/Page";
import Spinner from "../../components/Spinners";
import { api } from "../../helpers/api";
import {
  commaSeparatedNumber,
  formatNumber,
  getUser,
} from "../../helpers/utils";
import { AddUserModal } from "./AddUserModal";
import { AnalyticsCard } from "./components/AnalyticsCard";
import { RevenueChart } from "./components/RevenueChart";
import { Subscribers } from "./components/Subscription";

export function Dashboard() {
  const user = getUser();
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const { data, refetch, isLoading } = useQuery({
    queryKey: ["dashboard", user?.id],
    queryFn: () => api.getDashboardReport(user.id),
    enabled: !!user?.id,
  });
  return (
    <Page>
      <div
        className={`p-4 md:h-[calc(100dvh-62px)] lg:h-[100dvh] bg-surface-secondary flex-1 1xl:w-[unset]`}
      >
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-semibold text-content-primary">
            Dashboard
          </h1>
          <Button
            className="w-fit !bg-black"
            onClick={() => setIsAddUserModalOpen(true)}
          >
            Add admin user
          </Button>
        </div>
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <Spinner className="text-brand-primary" />
          </div>
        ) : (
          <>
            <div className="my-5 ">
              <div className="flex gap-4 items-center bg-surface-primary p-4 sm:p-5 lg:p-6 xl:p-3 2xl:p-5 rounded-lg shadow-soft border border-border-primary">
                <AnalyticsCard
                  title="Total # of users"
                  value={commaSeparatedNumber(Number(data?.totalUsers))}
                  className="flex-1"
                />
                <AnalyticsCard
                  title="# of users connected MEWS"
                  value={commaSeparatedNumber(Number(data?.totalMewsUsers))}
                  className="flex-1"
                />
                <AnalyticsCard
                  title="# of users connected Cloudbeds"
                  value={commaSeparatedNumber(
                    Number(data?.totalCloudbedsUsers),
                  )}
                  className="flex-1"
                />
                <AnalyticsCard
                  title="Total revenue"
                  value={`$${formatNumber(Number(data?.totalRevenue))}`}
                  className="flex-1"
                />
              </div>
            </div>
            <div className="flex gap-4">
              <RevenueChart />
              <Subscribers />
            </div>
          </>
        )}
      </div>
      {isAddUserModalOpen && (
        <AddUserModal onClose={() => setIsAddUserModalOpen(false)} />
      )}
    </Page>
  );
}
